import { ChatCircle } from '@phosphor-icons/react';

export default ChatCircle;
